import { useState, useEffect, useRef } from 'react';
import ReCaptcha from 'react-google-recaptcha';
import { useHistory } from 'react-router-dom';

import { getExistence } from '../../../api/User.api';
import key from '../../../assets/bx_bxs-key.svg';
import user from '../../../assets/bx_bxs-user.svg';
import email from '../../../assets/email.svg';
import fb from '../../../assets/fb icon.svg';
import google from '../../../assets/google icon.svg';
import invalidIcon from '../../../assets/invalid.svg';
import linkedin from '../../../assets/Linkedin icon.svg';
import loadingAnim from '../../../assets/loading.gif';
import signup from '../../../assets/signup.png';
import tick from '../../../assets/tick.svg';
import twitter from '../../../assets/twitter icon.svg';
import { signInWithSSO } from '../../../auth/Auth';
import { signUp } from '../../../auth/Auth';
import Button from '../../../components/Button';
import TextInput from '../../../components/TextInput';
import { SIGN_UP_FORM } from '../../../constants/FormNames';
import { AuthTypes } from '../../../constants/Types';
import { checkHasErrors } from '../../../constants/Validations';
import { ValidationTypes } from '../../../enums/ValidationTypes';

const SignUp = ({ formData }) => {
	const navigate = useHistory();
	const captchaRef = useRef<any | null | undefined>();
	const [signupError, setsignupError] = useState(false);
	const [usernameValid, setUsernameValid] = useState(false);
	const [unameIcon, setUnameIcon] = useState('loading');
	const [recaptchaToken, setrecaptchaToken] = useState<
		null | undefined | string
	>();
	const [signUpWithEmail, setsignUpWithEmail] = useState(false);
	const imgs = { loading: loadingAnim, valid: tick, invalid: invalidIcon };

	const onSucess = (data: any) => {
		console.log(user);
		navigate.push(`/${data.userName}`);
	};

	const onError = (error?: string) => {
		console.log(error);
		setsignupError(true);
	};

	const onPressSignUp = () => {
		signUpWithEmail &&
			signUp(
				formData.username.toLowerCase(),
				formData.email,
				formData.password,
				recaptchaToken,
				onSucess,
				onError
			);
		!signUpWithEmail && setsignUpWithEmail(true);
	};

	const disabledIcons = () => {
		return (
			!checkHasErrors(SIGN_UP_FORM, ['username']) &&
			usernameValid &&
			formData.username !== '' &&
			recaptchaToken
		);
	};

	const onPressFacebookSignIn = () =>
		disabledIcons() &&
		signInWithSSO(
			AuthTypes.FACEBOOK,
			onSucess,
			onError,
			formData.username.toLowerCase()
		);
	const onPressGoogleSignIn = () =>
		disabledIcons() &&
		signInWithSSO(
			AuthTypes.GOOGLE,
			onSucess,
			onError,
			formData.username.toLowerCase()
		);
	const onPressTwitterSignIn = () =>
		disabledIcons() &&
		signInWithSSO(
			AuthTypes.TWITTER,
			onSucess,
			onError,
			formData.username.toLowerCase()
		);
	const onPressLinkedIn = () =>
		disabledIcons() &&
		signInWithSSO(
			AuthTypes.LINKEDIN,
			onSucess,
			onError,
			formData.username.toLowerCase()
		);

	const disabled = () => {
		return (
			checkHasErrors(SIGN_UP_FORM, ['username', 'email', 'password']) ||
			signupError
		);
	};

	const validateUserName = async () => {
		const validity: any = await getExistence({
			name: formData.username?.toLowerCase(),
		});
		setUnameIcon(validity.exists ? 'invalid' : 'valid');
		setUsernameValid(!validity.exists);
	};

	useEffect(() => {
		setUnameIcon('loading');
		setUsernameValid(false);
		const timeOutId = setTimeout(() => {
			formData.username.trim() && validateUserName();
		}, 2000);
		return () => clearTimeout(timeOutId);
	}, [formData.username]);

	return (
		<div className='signup__container'>
			<div className='signup__box'>
				<p className='company__name'>
					<p onClick={() => navigate.push('/home')}>Webbler</p>
				</p>
				<p className='signup_text'>
					Already have an account?{' '}
					<p onClick={() => navigate.push('/login')}>Sign in</p>
				</p>
				<div className='box'>
					<div className='img_wrap'>
						<img className='login_img' src={signup} alt='Login image' />
					</div>
					<div className='form'>
						<div className='text_box'>
							<h3 className='welcome'>Create an Account</h3>
							<h6 className='welcome_sub1'>start creating your page!</h6>
						</div>
						<div className='inputbox-container'>
							<div className='input_box'>
								<TextInput
									onFocus={() => setsignupError(false)}
									type='text'
									name='username'
									transform='lower'
									id='username'
									placeholder='Username'
									form={SIGN_UP_FORM}
									validations={[ValidationTypes.username]}
									hidden={false}
									rightSideIcon={formData.username ? imgs[unameIcon] : null}
									mainIcon={user}
								/>
								<TextInput
									onFocus={() => setsignupError(false)}
									type='email'
									name='email'
									errorText={signupError ? 'Email already exist!' : null}
									id='email'
									placeholder='Email address'
									form={SIGN_UP_FORM}
									validations={[ValidationTypes.email, ValidationTypes.required]}
									hidden={!signUpWithEmail}
									mainIcon={email}
								/>
								<TextInput
									onFocus={() => setsignupError(false)}
									type='password'
									name='password'
									id='password'
									placeholder='Password'
									form={SIGN_UP_FORM}
									validations={[ValidationTypes.password, ValidationTypes.required]}
									hidden={!signUpWithEmail}
									mainIcon={key}
								/>
								<span className='form-error-message'>a</span>
							</div>
						</div>
						<div className='bottom_group'>
							{usernameValid && (
								<div className='recaptcha_wrap'>
									<ReCaptcha
										sitekey='6LdBlmIhAAAAADCCOGlGwbxwARkisslSl7jRdpKp'
										onChange={v => {
											setrecaptchaToken(v);
										}}
										ref={captchaRef}
									/>
								</div>
							)}
							<div className='btn_box'>
								<Button
									active
									clicked={!signupError && signUpWithEmail}
									className='login'
									diactivated={!disabledIcons() || (signUpWithEmail && disabled())}
									id='submit'
									labal={signUpWithEmail ? 'Sign up' : 'Sign Up with Email'}
									onClickEvent={onPressSignUp}
								/>
							</div>
							<div className='sso_1'>
								<div className='sso__icons1'>
									<div className='sso-caption'>
										<div className='line'></div>
										<span>Sign in with</span>
										<div className='line'></div>
									</div>
									<div className='image-button-wrapper'>
										<img
											src={fb}
											alt='fb image'
											aria-hidden='true'
											style={disabledIcons() ? {} : { opacity: 0.5 }}
											onClick={onPressFacebookSignIn}
										/>
										<img
											src={google}
											alt='google image'
											aria-hidden='true'
											style={disabledIcons() ? {} : { opacity: 0.5 }}
											onClick={onPressGoogleSignIn}
										/>

										<img
											src={linkedin}
											alt='linkedin image'
											aria-hidden='true'
											style={disabledIcons() ? {} : { opacity: 0.5 }}
											onClick={onPressLinkedIn}
										/>
										<img
											src={twitter}
											style={disabledIcons() ? {} : { opacity: 0.5 }}
											alt='twitter image'
											aria-hidden='true'
											onClick={onPressTwitterSignIn}
										/>
									</div>
								</div>
								<div className='privacy_policy'>
									<span onClick={() => navigate.push('/privacy-policy')}>
										Privacy Policy
									</span>
								</div>
							</div>
							<div className='signup_bottom'>
								Already have an account?{' '}
								<span onClick={() => navigate.push('/login')}>Sign in</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SignUp;
